import { render, staticRenderFns } from "./SubcategoryItem.vue?vue&type=template&id=b80a659c&"
import script from "./SubcategoryItem.vue?vue&type=script&lang=ts&"
export * from "./SubcategoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./SubcategoryItem.vue?vue&type=style&index=0&id=b80a659c&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports